require('./runtime');
(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("./utils"), require("./button"), require("./baseinput"));
	else if(typeof define === 'function' && define.amd)
		define(["./utils", "./button", "./baseinput"], factory);
	else {
		var a = typeof exports === 'object' ? factory(require("./utils"), require("./button"), require("./baseinput")) : factory(root["./utils"], root["./button"], root["./baseinput"]);
		for(var i in a) (typeof exports === 'object' ? exports : root)[i] = a[i];
	}
})(window, function(__WEBPACK_EXTERNAL_MODULE__4__, __WEBPACK_EXTERNAL_MODULE__15__, __WEBPACK_EXTERNAL_MODULE__33__) {
return (window["wpBaUiCarbonToolkit"] = window["wpBaUiCarbonToolkit"] || []).push([[66],{

/***/ 0:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireDefault");

/***/ }),

/***/ 1:
/***/ (function(module, exports) {

module.exports = require("react");

/***/ }),

/***/ 10:
/***/ (function(module, exports) {

module.exports = require("style-loader/lib/addStyles");

/***/ }),

/***/ 11:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/assertThisInitialized");

/***/ }),

/***/ 12:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-ui-carbon");

/***/ }),

/***/ 127:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _utils = __webpack_require__(4);

var _TimePickerResources = _interopRequireDefault(__webpack_require__(551));

/* IBM Confidential
*
* OCO Source Materials
*
* IBM Cognos Products: ba-ui-toolkit
* (C) Copyright IBM Corp. 2019
*
* The source code for this program is not published or otherwise
* divested of its trade secrets, irrespective of what has been
* deposited with the U.S. Copyright Office.
* NLS_ENCODING=UTF-8
* NLS_MESSAGEFORMAT_NONE
*/
// eslint-disable-line
var _default = new _utils.StringResource(_TimePickerResources["default"]);

exports["default"] = _default;

/***/ }),

/***/ 15:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__15__;

/***/ }),

/***/ 2:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/interopRequireWildcard");

/***/ }),

/***/ 3:
/***/ (function(module, exports) {

module.exports = require("prop-types");

/***/ }),

/***/ 33:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__33__;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

module.exports = __WEBPACK_EXTERNAL_MODULE__4__;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/inheritsLoose");

/***/ }),

/***/ 53:
/***/ (function(module, exports) {

module.exports = require("react-moment-proptypes");

/***/ }),

/***/ 541:
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(542);


/***/ }),

/***/ 542:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;

var _TimePicker = _interopRequireDefault(__webpack_require__(543));

exports["default"] = _TimePicker["default"];
exports.TimePicker = _TimePicker["default"];

/***/ }),

/***/ 543:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(__webpack_require__(8));

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _utils = __webpack_require__(4);

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _baseinput = _interopRequireDefault(__webpack_require__(33));

var _baUiCarbon = __webpack_require__(12);

var _time_ = _interopRequireDefault(__webpack_require__(544));

var _reactMomentProptypes = _interopRequireDefault(__webpack_require__(53));

var _momentTimezone = _interopRequireDefault(__webpack_require__(545));

var _TimeSlot = _interopRequireDefault(__webpack_require__(546));

var _TimePicker = _interopRequireDefault(__webpack_require__(552));

var _StringResource = _interopRequireDefault(__webpack_require__(127));

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-carbon-toolkit
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var timepickerClassName = _TimePicker["default"].timepickerClassName.replace(/"/g, '');

var sanitize = _utils.propsUtils.sanitize;
var AMPM_LABEL = ['AM', 'PM'];

function getString(value) {
  return _StringResource["default"].get(value);
}

var TimePicker = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(TimePicker, _Component);

  function TimePicker() {
    var _this;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      initialFoucsed: false,
      is24hour: false
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getFormattedTime", function () {
      var newTime;
      var showSec = _this.props.showSec;
      var _this$state = _this.state,
          time = _this$state.time,
          is24hour = _this$state.is24hour;

      if (showSec) {
        var h = time.h,
            m = time.m,
            a = time.a,
            s = time.s;
        var value = h + ":" + m + ":" + s + " " + AMPM_LABEL[parseInt(a, 10)];
        var tempMoment = (0, _momentTimezone["default"])(value, is24hour ? 'HH:mm:ss' : 'h:mm:ss A');
        newTime = (0, _momentTimezone["default"])(_this.props.time).hour(tempMoment.hour()).minute(tempMoment.minute()).second(tempMoment.second());
      } else {
        var _h = time.h,
            _m = time.m,
            _a = time.a;

        var _value = _h + ":" + _m + " " + AMPM_LABEL[parseInt(_a, 10)];

        var _tempMoment = (0, _momentTimezone["default"])(_value, is24hour ? 'HH:mm' : 'h:mm A');

        newTime = (0, _momentTimezone["default"])(_this.props.time).hour(_tempMoment.hour()).minute(_tempMoment.minute());
      }

      return newTime;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_getNewTimeByUnit", function (num, unit) {
      var newTime = (0, _extends2["default"])({}, _this.state.time);
      newTime[unit] = parseInt(num, 10);
      return newTime;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onChange", function (v) {
      var is24hour = _this.state.is24hour;
      var time = [0, 0, 0];

      if (v !== '') {
        time = v.match(/[0-9]+/g);
      }

      if (time) {
        var _time$map = time.map(function (t) {
          return parseInt(t, 10);
        }),
            hour = _time$map[0],
            min = _time$map[1],
            sec = _time$map[2];

        var newStates = {
          value: v,
          time: {
            h: hour,
            m: min,
            s: sec
          }
        }; // process am pm

        if (!is24hour) {
          var lastString = v.substr(v.indexOf(' '));
          var ampmIdx = AMPM_LABEL.indexOf(lastString.trim().toUpperCase());

          if (ampmIdx > -1) {
            newStates.time.a = ampmIdx;
          }
        } else if (hour < 12) {
          newStates.time.a = 0;
        } else {
          newStates.time.a = 1;
        } // process hour


        if (is24hour && hour >= 24) {
          newStates.time.h = hour % 24;
        } else if (!is24hour && hour > 12) {
          newStates.time.h = hour % 12 || hour;
          newStates.time.a = 1;
        } else if (is24hour && hour < 0) {
          newStates.time.h = 23;
        } else if (!is24hour && hour < 1) {
          newStates.time.h = 12;
          newStates.time.a = 0;
        } else {
          newStates.time.h = hour;
        } // process min and sec


        if (min && min > 59) newStates.time.m = 59;
        if (sec && sec > 59) newStates.time.s = 59;

        _this.setState(newStates);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_ref", function (node) {
      _this._node = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_inputRef", function (node) {
      _this.inputRef = node;
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onClickAway", function (e) {
      if (_this._node.contains && !_this._node.contains(e.target)) {
        var focused = _this.props.focused;
        var isFocused = focused === null ? _this.state.initialFoucsed : focused;

        if (isFocused) {
          _this._focusController(false);
        }
      } else {
        _this._focusController(true);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_onKeyDown", function (e) {
      if (e.keyCode === 27 || e.keyCode === 13) {
        _this._focusController(false);
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_focusController", function (toBeFocused) {
      var _this$props = _this.props,
          onFocusChange = _this$props.onFocusChange,
          focused = _this$props.focused,
          onChange = _this$props.onChange;

      if (focused == null) {
        _this.setState({
          initialFoucsed: toBeFocused
        });
      }

      onChange && onChange(_this._getFormattedTime());
      onFocusChange && onFocusChange(toBeFocused);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "_inputToRender", function (props) {
      return (
        /*#__PURE__*/
        // return <CarbonTimePickerInput {...props} />;
        _react["default"].createElement(_baUiCarbon.TextInput, props)
      );
    });
    return _this;
  }

  TimePicker.format = function format(value, is24hour) {
    return value.format(is24hour ? 'HH:mm' : 'h:mm A');
  };

  var _proto = TimePicker.prototype;

  _proto.componentWillMount = function componentWillMount() {
    var time = this.props.time;

    this._updateInternalTime(this._getValidTime(time));
  };

  _proto.componentDidMount = function componentDidMount() {
    // Must use document to let the listener cover the parent domNode
    document.addEventListener('click', this._onClickAway);
  };

  _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var time = nextProps.time;

    if (time && (!this.props.time || this.props.time.format() !== time.format())) {
      this._updateInternalTime(this._getValidTime(time));
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    document.removeEventListener('click', this._onClickAway);
  };

  _proto._getValidTime = function _getValidTime(time) {
    var validTime;
    var locale = this.props.locale; // initialte the locale for moment objects.

    _momentTimezone["default"].locale(locale); // eslint-disable-next-line no-underscore-dangle


    if (time._isAMomentObject && time.isValid()) {
      validTime = (0, _momentTimezone["default"])(time);
    } else {
      console.warn("Your time prop value, " + time + ", is not valid, the current time is used instead."); // eslint-disable-line no-console

      validTime = (0, _momentTimezone["default"])();
    }

    return validTime;
  };

  _proto._updateInternalTime = function _updateInternalTime(time) {
    var _this$props2 = this.props,
        showSec = _this$props2.showSec,
        locale = _this$props2.locale;

    var timeFormat = _momentTimezone["default"].localeData(locale).longDateFormat('LT');

    var is24hour = timeFormat.indexOf('H') > -1;
    var timeString;

    if (showSec) {
      timeString = time.format(is24hour ? 'HH:mm:ss' : 'h:mm:ss A');
    } else {
      timeString = time.format(is24hour ? 'HH:mm' : 'h:mm A');
    }

    var newTime = {};
    newTime.h = parseInt(time.format(is24hour ? 'HH' : 'h'), 10);
    newTime.m = parseInt(time.format('mm'), 10);
    showSec && (newTime.s = parseInt(time.format('ss'), 10));

    if (!is24hour) {
      // Not ideal but... to get translated labels for AM and PM from moment
      AMPM_LABEL = [(0, _momentTimezone["default"])('10:00 AM', 'h:mm A').format('A'), (0, _momentTimezone["default"])('2:00 PM', 'h:mm A').format('A')];
      newTime.a = time.hours() < 12 ? 0 : 1;
    }

    this.setState({
      time: newTime,
      value: timeString,
      is24hour: is24hour
    });
  };

  _proto.render = function render() {
    var _this2 = this;

    var _this$props3 = this.props,
        dir = _this$props3.dir,
        focused = _this$props3.focused,
        time = _this$props3.time,
        showSec = _this$props3.showSec,
        disabled = _this$props3.disabled,
        className = _this$props3.className,
        style = _this$props3.style,
        timeInputExtraOptions = _this$props3.timeInputExtraOptions,
        getLocaleString = _this$props3.getLocaleString,
        light = _this$props3.light,
        others = (0, _objectWithoutPropertiesLoose2["default"])(_this$props3, ["dir", "focused", "time", "showSec", "disabled", "className", "style", "timeInputExtraOptions", "getLocaleString", "light"]);
    var is24hour = this.state.is24hour;
    var _this$state$time = this.state.time,
        h = _this$state$time.h,
        m = _this$state$time.m,
        s = _this$state$time.s,
        a = _this$state$time.a;
    var inputProps = {
      light: light,
      fullWidth: true,
      value: this.state.value,
      iconLeft: _time_["default"].id,
      onFocus: function onFocus() {
        _this2._focusController(true);
      },
      onChange: this._onChange,
      onKeyDown: this._onKeyDown,
      disabled: disabled || !time,
      ref: this._inputRef,
      'data-tid': 'ba-common-time-picker__input',
      dir: dir
    };
    var isFocused = !disabled && focused === null ? this.state.initialFoucsed : focused;

    if (showSec) {
      inputProps.step = '1';
    }

    var classNames = (0, _utils.classnames)(timepickerClassName, {
      focused: isFocused,
      showSec: showSec,
      disabled: disabled
    });
    return /*#__PURE__*/_react["default"].createElement("div", (0, _extends2["default"])({}, sanitize(others, TimePicker), {
      role: "region",
      "aria-label": getLocaleString('timePicker'),
      className: classNames + " " + className,
      ref: this._ref,
      style: style
    }), /*#__PURE__*/_react["default"].createElement(_baseinput["default"], (0, _extends2["default"])({
      inputToRender: this._inputToRender
    }, timeInputExtraOptions, inputProps, {
      ref: this._inputRef,
      dir: dir
    })), isFocused && /*#__PURE__*/_react["default"].createElement("div", {
      className: timepickerClassName + "__time-slots",
      onKeyDown: this._onKeyDown,
      dir: "ltr"
    }, is24hour && /*#__PURE__*/_react["default"].createElement(_TimeSlot["default"], {
      getLocaleString: getLocaleString,
      onChange: function onChange(num) {
        _this2.setState({
          time: _this2._getNewTimeByUnit(num, 'h')
        });
      },
      unit: "tfh",
      index: parseInt(h, 10)
    }), !is24hour && /*#__PURE__*/_react["default"].createElement(_TimeSlot["default"], {
      getLocaleString: getLocaleString,
      onChange: function onChange(num) {
        _this2.setState({
          time: _this2._getNewTimeByUnit(num, 'h')
        });
      },
      unit: "h",
      index: parseInt(h - 1, 10)
    }), /*#__PURE__*/_react["default"].createElement(_TimeSlot["default"], {
      getLocaleString: getLocaleString,
      onChange: function onChange(num) {
        _this2.setState({
          time: _this2._getNewTimeByUnit(num, 'm')
        });
      },
      unit: "m",
      index: parseInt(m, 10)
    }), showSec && /*#__PURE__*/_react["default"].createElement(_TimeSlot["default"], {
      getLocaleString: getLocaleString,
      onChange: function onChange(num) {
        _this2.setState({
          time: _this2._getNewTimeByUnit(num, 's')
        });
      },
      unit: "s",
      index: parseInt(s, 10)
    }), !is24hour && /*#__PURE__*/_react["default"].createElement(_TimeSlot["default"], {
      getLocaleString: getLocaleString,
      onChange: function onChange(num) {
        _this2.setState({
          time: _this2._getNewTimeByUnit(num, 'a')
        });
      },
      unit: "a",
      ampmLabel: AMPM_LABEL,
      index: parseInt(a, 10)
    })));
  };

  return TimePicker;
}(_react.Component);

exports["default"] = TimePicker;
(0, _defineProperty2["default"])(TimePicker, "propTypes", {
  /** To set direction */
  dir: _propTypes["default"].oneOf(['rtl', 'ltr']),

  /** Set initial focused state */
  focused: _propTypes["default"].bool,

  /** Allow seconds edit */
  showSec: _propTypes["default"].bool,

  /** Disable time picker */
  disabled: _propTypes["default"].bool,

  /** Function that is called when time is changed */
  onChange: _propTypes["default"].func,

  /** Function that is called when focus is changed */
  onFocusChange: _propTypes["default"].func,

  /** Initial time */
  time: _reactMomentProptypes["default"].momentObj,

  /** Classname to be given to the container of TagInput */
  className: _propTypes["default"].string,

  /** Custom CSS styling */
  style: _propTypes["default"].object,
  getLocaleString: _propTypes["default"].func,
  timeInputExtraOptions: _propTypes["default"].object,
  // locale for time picker
  locale: _propTypes["default"].string,
  // Carbon light variant of the component
  light: _propTypes["default"].bool
});
(0, _defineProperty2["default"])(TimePicker, "defaultProps", {
  onFocusChange: function onFocusChange() {},
  focused: null,
  onChange: function onChange() {},
  className: '',
  style: {},
  timeInputExtraOptions: {},
  getLocaleString: getString,
  locale: 'en'
});

/***/ }),

/***/ 544:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/time_32");

/***/ }),

/***/ 545:
/***/ (function(module, exports) {

module.exports = require("moment-timezone");

/***/ }),

/***/ 546:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(2);

var _interopRequireDefault = __webpack_require__(0);

exports.__esModule = true;
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(7));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(11));

var _inheritsLoose2 = _interopRequireDefault(__webpack_require__(5));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(6));

var _react = _interopRequireWildcard(__webpack_require__(1));

var _propTypes = _interopRequireDefault(__webpack_require__(3));

var _button = _interopRequireDefault(__webpack_require__(15));

var _chevronDown_ = _interopRequireDefault(__webpack_require__(547));

var _chevronUp_ = _interopRequireDefault(__webpack_require__(548));

var _TimeSlot = _interopRequireDefault(__webpack_require__(549));

var _StringResource = _interopRequireDefault(__webpack_require__(127));

/* eslint-disable no-plusplus */

/* IBM Confidential
 *
 * OCO Source Materials
 *
 * IBM Cognos Products: ba-ui-common
 * (C) Copyright IBM Corp. 2019, 2020
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 * NLS_ENCODING=UTF-8
 * NLS_MESSAGEFORMAT_NONE
 */
var timeSlotClassName = _TimeSlot["default"].timeSlotClassName.replace(/"/g, '');

function getString(value) {
  return _StringResource["default"].get(value);
} // TODO:duplicated


var TWENTY_FOUR_HOURS = 23;
var HOURS = 11;
var MINUTES = 59;
var SECONDS = 59;
var TIMES = {
  tfh: 23,
  h: 11,
  m: 59,
  s: 59,
  a: 1
};

var TimeSlot = /*#__PURE__*/function (_Component) {
  (0, _inheritsLoose2["default"])(TimeSlot, _Component);

  function TimeSlot(props) {
    var _this;

    _this = _Component.call(this, props) || this;
    _this.increment = _this.increment.bind((0, _assertThisInitialized2["default"])(_this));
    _this.decrement = _this.decrement.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  var _proto = TimeSlot.prototype;

  _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
    var unit = nextProps.unit,
        index = nextProps.index;

    switch (true) {
      case index > TIMES[unit]:
        return false;

      case index < 0:
        return false;

      default:
    }

    return true;
  };

  _proto.increment = function increment(index) {
    var _this$props = this.props,
        onChange = _this$props.onChange,
        unit = _this$props.unit;
    var nextValue = index + 1;

    if (nextValue <= TIMES[unit]) {
      onChange(this.regulateNum(unit, nextValue));
    } else {
      onChange(this.regulateNum(unit, 0));
    }
  };

  _proto.decrement = function decrement(index) {
    var _this$props2 = this.props,
        onChange = _this$props2.onChange,
        unit = _this$props2.unit;
    var lowestValue = 0;
    var nextValue = index - 1;

    if (nextValue >= lowestValue) {
      onChange(this.regulateNum(unit, nextValue));
    } else {
      onChange(this.regulateNum(unit, TIMES[unit]));
    }
  };

  _proto.convertNum = function convertNum(unit, num) {
    if (unit === 'a') {
      return this.props.ampmLabel[num];
    }

    if (unit === 'h') {
      num = parseInt(num, 10) + 1;
    }

    if (num < 10) {
      return 0 + num.toString();
    }

    return num;
  };

  _proto.regulateNum = function regulateNum(unit, num) {
    var number = parseInt(num, 10);

    if (unit === 'h') {
      number += 1;
    }

    return number;
  };

  _proto._arrow = function _arrow(direction) {
    var iconProps = {
      variant: 'icon',
      intent: 'primary',
      size: 'small'
    };
    var _this$props3 = this.props,
        unit = _this$props3.unit,
        index = _this$props3.index,
        getLocaleString = _this$props3.getLocaleString;
    var labelPrefix = direction === 'up' ? 'increase' : 'decrease';
    var clickHandler = direction === 'up' ? this.increment : this.decrement;
    var tooltipPos = direction === 'up' ? 'left' : 'bottom';
    var icon = direction === 'up' ? _chevronUp_["default"].id : _chevronDown_["default"].id;
    var toolipTitle = direction === 'up' ? getLocaleString('increment') : getLocaleString('decrement');
    var ariaLebel;

    switch (unit) {
      case 'h':
      case 'tfh':
        {
          ariaLebel = getLocaleString(labelPrefix + "Hour");
          break;
        }

      case 'm':
        {
          ariaLebel = getLocaleString(labelPrefix + "Minute");
          break;
        }

      case 's':
        {
          ariaLebel = getLocaleString(labelPrefix + "Second");
          break;
        }

      case 'a':
        {
          toolipTitle = getLocaleString('changeAMPM');
          ariaLebel = toolipTitle;
          break;
        }

      default:
        {
          return null;
        }
    }

    return /*#__PURE__*/_react["default"].createElement(_button["default"], (0, _extends2["default"])({
      "aria-label": ariaLebel
    }, iconProps, {
      icon: icon,
      iconDescription: toolipTitle,
      onClick: function onClick() {
        clickHandler(index);
      }
    }));
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        unit = _this$props4.unit,
        index = _this$props4.index;
    var times = [];

    switch (unit) {
      case 'tfh':
        {
          var tfh = 0;

          while (tfh <= TWENTY_FOUR_HOURS) {
            times.push(tfh++);
          }

          break;
        }

      case 'h':
        {
          var h = 0;

          while (h <= HOURS) {
            times.push(h++);
          }

          break;
        }

      case 'm':
        {
          var m = 0;

          while (m <= MINUTES) {
            times.push(m++);
          }

          break;
        }

      case 's':
        {
          var s = 0;

          while (s <= SECONDS) {
            times.push(s++);
          }

          break;
        }

      case 'a':
        {
          times = [0, 1];
          break;
        }

      default:
        {
          return null;
        }
    }

    return /*#__PURE__*/_react["default"].createElement("div", {
      className: timeSlotClassName
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: timeSlotClassName + "__" + unit + "__up"
    }, this._arrow('up')), /*#__PURE__*/_react["default"].createElement("div", {
      className: timeSlotClassName + "__item prev"
    }, this.convertNum(unit, times[index + 1]) || this.convertNum(unit, times[0])), /*#__PURE__*/_react["default"].createElement("div", {
      className: timeSlotClassName + "__item current"
    }, this.convertNum(unit, times[index])), /*#__PURE__*/_react["default"].createElement("div", {
      className: timeSlotClassName + "__item next"
    }, this.convertNum(unit, times[index - 1]) || this.convertNum(unit, times[TIMES[unit]])), /*#__PURE__*/_react["default"].createElement("div", {
      className: timeSlotClassName + "__" + unit + "__down"
    }, this._arrow('down')));
  };

  return TimeSlot;
}(_react.Component);

exports["default"] = TimeSlot;
(0, _defineProperty2["default"])(TimeSlot, "propTypes", {
  // to determine the time slot is a hour, min, sec or ampm
  unit: _propTypes["default"].oneOf(['tfh', 'h', 'm', 's', 'a']),
  onChange: _propTypes["default"].func,
  index: _propTypes["default"].number,
  getLocaleString: _propTypes["default"].func,
  ampmLabel: _propTypes["default"].arrayOf(_propTypes["default"].string)
});
(0, _defineProperty2["default"])(TimeSlot, "defaultProps", {
  getLocaleString: getString,
  ampmLabel: ['AM', 'PM']
});

/***/ }),

/***/ 547:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/chevron-down_16");

/***/ }),

/***/ 548:
/***/ (function(module, exports) {

module.exports = require("@ba/ba-graphics/dist/icons-js/chevron-up_16");

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(550);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-timeslot{font-size:.75rem;line-height:1rem}.ba-common-timeslot:not(:last-child){padding-right:8px}.ba-common-timeslot .ba-common-button{padding:0px}.ba-common-timeslot__item{display:flex;justify-content:center;align-items:center;height:40px;color:#161616}.ba-common-timeslot__item.current{color:#fff;font-size:.875rem;font-weight:400;line-height:1.125rem;letter-spacing:.16px}.ba-common-timeslot__a__up,.ba-common-timeslot__a__down{text-align:center}\n", ""]);

// exports
exports.locals = {
	"timeSlotClassName": "\"ba-common-timeslot\""
};

/***/ }),

/***/ 551:
/***/ (function(module, exports) {

var amdi18n={"__root":{"increaseHour":"Increase Hour","increaseMinute":"Increase Minute","increaseSecond":"Increase Second","decreaseHour":"Decrease Hour","decreaseMinute":"Decrease Minute","decreaseSecond":"Decrease Second","increment":"Increment","decrement":"Decrement","timePicker":"Time picker","changeAMPM":"Change AM/PM"},"__cs":{"increaseHour":"Zvýšit hodiny","increaseMinute":"Zvýšit minuty","increaseSecond":"Zvýšit sekundy","decreaseHour":"Snížit hodiny","decreaseMinute":"Snížit minuty","decreaseSecond":"Snížit sekundy","increment":"Zvýšit","decrement":"Snížit","timePicker":"Nástroj pro výběr času","changeAMPM":"Změnit dop./odp."},"__da":{"increaseHour":"Forøg time","increaseMinute":"Forøg minut","increaseSecond":"Forøg sekund","decreaseHour":"Formindsk time","decreaseMinute":"Formindsk minut","decreaseSecond":"Formindsk sekund","increment":"Forøgelse","decrement":"Formindskelse","timePicker":"Tidsvælger","changeAMPM":"Skift AM/PM"},"__de":{"increaseHour":"Stunde erhöhen","increaseMinute":"Minute erhöhen","increaseSecond":"Sekunde erhöhen","decreaseHour":"Stunde verringern","decreaseMinute":"Minute verringern","decreaseSecond":"Sekunde verringern","increment":"Schrittweise erhöhen","decrement":"Schrittweise verringern","timePicker":"Zeitauswahlfeld","changeAMPM":"AM/PM ändern"},"__es":{"increaseHour":"Aumentar hora","increaseMinute":"Aumentar minuto","increaseSecond":"Aumentar segundo","decreaseHour":"Disminuir hora","decreaseMinute":"Disminuir minuto","decreaseSecond":"Disminuir segundo","increment":"Incremento","decrement":"Reducción","timePicker":"Selector de tiempo","changeAMPM":"Cambiar AM/PM"},"__fi":{"increaseHour":"Lisää tunti","increaseMinute":"Lisää minuutti","increaseSecond":"Lisää sekunti","decreaseHour":"Vähennä tunti","decreaseMinute":"Vähennä minuutti","decreaseSecond":"Vähennä sekunti","increment":"Lisäys","decrement":"Vähennys","timePicker":"Kellonajan valitsin","changeAMPM":"Vaihda AP/IP"},"__fr":{"increaseHour":"Augmenter l'heure","increaseMinute":"Augmenter les minutes","increaseSecond":"Augmenter les secondes","decreaseHour":"Réduire l'heure","decreaseMinute":"Réduire les minutes","decreaseSecond":"Réduire les secondes","increment":"Incrémenter","decrement":"Décrémenter","timePicker":"Sélecteur d'heure","changeAMPM":"Modifier AM/PM"},"__hr":{"increaseHour":"Povećaj sate","increaseMinute":"Povećaj minute","increaseSecond":"Povećaj sekunde","decreaseHour":"Smanji sate","decreaseMinute":"Smanji minute","decreaseSecond":"Smanji sekunde","increment":"Povećanje","decrement":"Smanjenje","timePicker":"Probirač vremena","changeAMPM":"Promijeni AM/PM"},"__hu":{"increaseHour":"Óra növelése","increaseMinute":"Perc növelése","increaseSecond":"Másodperc növelése","decreaseHour":"Óra csökkentése","decreaseMinute":"Perc csökkentése","decreaseSecond":"Másodperc csökkentése","increment":"Növelés","decrement":"Csökkentés","timePicker":"Időpontválasztó","changeAMPM":"AM/PM (napszak) módosítása"},"__it":{"increaseHour":"Incrementa orario","increaseMinute":"Incrementa minuto","increaseSecond":"Incrementa secondo","decreaseHour":"Riduci orario","decreaseMinute":"Riduci minuto","decreaseSecond":"Riduci secondo","increment":"Incrementa","decrement":"Decrementa","timePicker":"Selettore orario","changeAMPM":"Modifica AM/PM"},"__ja":{"increaseHour":"時間の増加","increaseMinute":"分の増加","increaseSecond":"秒の増加","decreaseHour":"時間の減少","decreaseMinute":"分の減少","decreaseSecond":"秒の減少","increment":"増分","decrement":"減分","timePicker":"時刻ピッカー","changeAMPM":"AM/PM の変更"},"__kk":{"increaseHour":"Сағатты көбейтіңіз","increaseMinute":"Минутты көбейтіңіз","increaseSecond":"Секундды көбейтіңіз","decreaseHour":"Сағатты азайтыңыз","decreaseMinute":"Минутты азайтыңыз","decreaseSecond":"Секундты азайтыңыз","increment":"Арту","decrement":"Кему","timePicker":"Уақыт таңдаушы","changeAMPM":"AM/PM өзгерту"},"__ko":{"increaseHour":"시 증가","increaseMinute":"분 증가","increaseSecond":"초 증가","decreaseHour":"시 감소","decreaseMinute":"분 감소","decreaseSecond":"초 감소","increment":"증분","decrement":"감량","timePicker":"시간 선택도구","changeAMPM":"오전/오후 변경"},"__nb":{"increaseHour":"Øk time","increaseMinute":"Øk minutt","increaseSecond":"Øk sekund","decreaseHour":"Reduser time","decreaseMinute":"Reduser minutt","decreaseSecond":"Reduser sekund","increment":"Økning","decrement":"Reduksjon","timePicker":"Klokkeslettvelger","changeAMPM":"Endre AM/PM"},"__nl":{"increaseHour":"Uur verhogen","increaseMinute":"Minuut verhogen","increaseSecond":"Seconde verhogen","decreaseHour":"Uur verlagen","decreaseMinute":"Minuut verlagen","decreaseSecond":"Seconde verlagen","increment":"Verhoging","decrement":"Verlaging","timePicker":"Tijdkiezer","changeAMPM":"AM/PM wijzigen"},"__no":{"increaseHour":"Øk time","increaseMinute":"Øk minutt","increaseSecond":"Øk sekund","decreaseHour":"Reduser time","decreaseMinute":"Reduser minutt","decreaseSecond":"Reduser sekund","increment":"Økning","decrement":"Reduksjon","timePicker":"Klokkeslettvelger","changeAMPM":"Endre AM/PM"},"__pl":{"increaseHour":"Zwiększ godziny","increaseMinute":"Zwiększ minuty","increaseSecond":"Zwiększ sekundy","decreaseHour":"Zmniejsz godziny","decreaseMinute":"Zmniejsz minuty","decreaseSecond":"Zmniejsz sekundy","increment":"Zwiększenie","decrement":"Zmniejszenie","timePicker":"Selektor godziny","changeAMPM":"Zmień format AM/PM"},"__pt":{"increaseHour":"Aumentar Hora","increaseMinute":"Aumentar Minuto","increaseSecond":"Aumentar Segundo","decreaseHour":"Diminuir Hora","decreaseMinute":"Diminuir Minuto","decreaseSecond":"Diminuir Segundo","increment":"Incrementar","decrement":"Decremento","timePicker":"Selecionador de tempo","changeAMPM":"Mudar AM/PM"},"__pt-br":{"increaseHour":"Aumentar Hora","increaseMinute":"Aumentar Minuto","increaseSecond":"Aumentar Segundo","decreaseHour":"Diminuir Hora","decreaseMinute":"Diminuir Minuto","decreaseSecond":"Diminuir Segundo","increment":"Incrementar","decrement":"Decremento","timePicker":"Selecionador de tempo","changeAMPM":"Mudar AM/PM"},"__ro":{"increaseHour":"Creştere oră","increaseMinute":"Creştere minute","increaseSecond":"Creştere secunde","decreaseHour":"Descreştere oră","decreaseMinute":"Descreştere minute","decreaseSecond":"Descreştere secunde","increment":"Increment","decrement":"Decrement","timePicker":"Selector oră","changeAMPM":"Modificare AM/PM"},"__ru":{"increaseHour":"Увеличить час","increaseMinute":"Увеличить минуту","increaseSecond":"Увеличить секунду","decreaseHour":"Уменьшить час","decreaseMinute":"Уменьшить минуту","decreaseSecond":"Уменьшить секунду","increment":"Увеличить","decrement":"Уменьшить","timePicker":"Выбор времени","changeAMPM":"Изменить AM/PM"},"__sl":{"increaseHour":"Povečaj uro","increaseMinute":"Povečaj minuto","increaseSecond":"Povečaj sekundo","decreaseHour":"Zmanjšaj uro","decreaseMinute":"Zmanjšaj minuto","decreaseSecond":"Zmanjšaj sekundo","increment":"Prirastek","decrement":"Zmanjšanje","timePicker":"Izbirnik časa","changeAMPM":"Spremeni dop/pop"},"__sv":{"increaseHour":"Öka timme","increaseMinute":"Öka minut","increaseSecond":"Öka sekund","decreaseHour":"Minska timme","decreaseMinute":"Minska minut","decreaseSecond":"Minska sekund","increment":"Öka","decrement":"Minska","timePicker":"Tidsväljare","changeAMPM":"Ändra AM/PM"},"__th":{"increaseHour":"เพิ่มชั่วโมง","increaseMinute":"เพิ่มนาที","increaseSecond":"เพิ่มวินาที","decreaseHour":"ลดชั่วโมง","decreaseMinute":"ลดนาที","decreaseSecond":"ลดวินาที","increment":"การเพิ่ม","decrement":"การลด","timePicker":"ตัวเลือกเวลา","changeAMPM":"เปลี่ยน AM/PM"},"__tr":{"increaseHour":"Saati Artır","increaseMinute":"Dakikayı Artır","increaseSecond":"Saniyeyi Artır","decreaseHour":"Saati Azalt","decreaseMinute":"Dakikayı Azalt","decreaseSecond":"Saniyeyi Azalt","increment":"Artır","decrement":"Azalt","timePicker":"Saat seçici","changeAMPM":"AM/PM Değiştir"},"__zh":{"increaseHour":"增加小时","increaseMinute":"增加分钟","increaseSecond":"增加秒","decreaseHour":"减少小时","decreaseMinute":"减少分钟","decreaseSecond":"减少秒","increment":"递增","decrement":"递减","timePicker":"时间选择器","changeAMPM":"更改 AM/PM"},"__zh-cn":{"increaseHour":"增加小时","increaseMinute":"增加分钟","increaseSecond":"增加秒","decreaseHour":"减少小时","decreaseMinute":"减少分钟","decreaseSecond":"减少秒","increment":"递增","decrement":"递减","timePicker":"时间选择器","changeAMPM":"更改 AM/PM"},"__zh-hk":{"increaseHour":"增加小時","increaseMinute":"增加分鐘","increaseSecond":"增加秒鐘","decreaseHour":"減少小時","decreaseMinute":"減少分鐘","decreaseSecond":"減少秒鐘","increment":"增量","decrement":"減量","timePicker":"時間選取器","changeAMPM":"變更 AM/PM"},"__zh-mo":{"increaseHour":"增加小時","increaseMinute":"增加分鐘","increaseSecond":"增加秒鐘","decreaseHour":"減少小時","decreaseMinute":"減少分鐘","decreaseSecond":"減少秒鐘","increment":"增量","decrement":"減量","timePicker":"時間選取器","changeAMPM":"變更 AM/PM"},"__zh-sg":{"increaseHour":"增加小时","increaseMinute":"增加分钟","increaseSecond":"增加秒","decreaseHour":"减少小时","decreaseMinute":"减少分钟","decreaseSecond":"减少秒","increment":"递增","decrement":"递减","timePicker":"时间选择器","changeAMPM":"更改 AM/PM"},"__zh-tw":{"increaseHour":"增加小時","increaseMinute":"增加分鐘","increaseSecond":"增加秒鐘","decreaseHour":"減少小時","decreaseMinute":"減少分鐘","decreaseSecond":"減少秒鐘","increment":"增量","decrement":"減量","timePicker":"時間選取器","changeAMPM":"變更 AM/PM"}};amdi18n.init=function (language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;

/***/ }),

/***/ 552:
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(553);
if(typeof content === 'string') content = [[module.i, content, '']];
// Prepare cssTransformation
var transform;

var options = {"modules":true,"hmr":true}
options.transform = transform
// add the styles to the DOM
var update = __webpack_require__(10)(content, options);
if(content.locals) module.exports = content.locals;
// Hot Module Replacement
if(false) {}

/***/ }),

/***/ 553:
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(9)(undefined);
// imports


// module
exports.push([module.i, ".ba-common-timepicker{display:inline-block;width:120px;height:42px}.ba-common-timepicker input[type=time]::-webkit-inner-spin-button,.ba-common-timepicker input[type=time]::-webkit-outer-spin-button{appearance:none}.ba-common-timepicker input[type=\"time\"]::-webkit-clear-button{display:none}.ba-common-timepicker.is-showSec{width:140px}.ba-common-timepicker.is-focused .ba-common-baseInput .ba-common-svgIcon{fill:#161616}.ba-common-timepicker__time-slots{display:flex;justify-content:space-between;padding:16px;position:absolute;z-index:999;background:#fff;border:1px solid #f4f4f4}@media screen and (-ms-high-contrast: active){.ba-common-timepicker__time-slots .ba-common-svgIcon{fill:#393939;border:1px solid #161616}}.ba-common-timepicker__time-slots:after{content:\"\";width:100%;height:40px;background-color:#0f62fe;position:absolute;left:0;bottom:42%;z-index:-1}.ba-common-timepicker .ba-common-baseInput{min-width:100%}[dir=\"ltr\"] .ba-common-timepicker .ba-common-baseInput.ba-common-baseInput .ba-common-baseInput__icon.is-left,.ba-common-timepicker .ba-common-baseInput .ba-common-baseInput[dir=\"ltr\"] .ba-common-baseInput__icon.is-left,.ba-common-timepicker .ba-common-baseInput .ba-common-baseInput .ba-common-baseInput__icon.is-left{left:16px}[dir=\"ltr\"] .ba-common-timepicker .ba-common-baseInput.ba-common-baseInput.is-iconLeft>input,.ba-common-timepicker .ba-common-baseInput .ba-common-baseInput[dir=\"ltr\"].is-iconLeft>input,.ba-common-timepicker .ba-common-baseInput .ba-common-baseInput.is-iconLeft>input{padding-left:40px}[dir=\"rtl\"] .ba-common-timepicker .ba-common-baseInput.ba-common-baseInput .ba-common-baseInput__icon.is-left,.ba-common-timepicker .ba-common-baseInput .ba-common-baseInput[dir=\"rtl\"] .ba-common-baseInput__icon.is-left{right:16px;left:unset}[dir=\"rtl\"] .ba-common-timepicker .ba-common-baseInput.ba-common-baseInput.is-iconLeft>input,.ba-common-timepicker .ba-common-baseInput .ba-common-baseInput[dir=\"rtl\"].is-iconLeft>input{padding-right:40px;padding-left:0px;text-align:right}\n", ""]);

// exports
exports.locals = {
	"timepickerClassName": "\"ba-common-timepicker\""
};

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/defineProperty");

/***/ }),

/***/ 7:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/extends");

/***/ }),

/***/ 8:
/***/ (function(module, exports) {

module.exports = require("@babel/runtime/helpers/objectWithoutPropertiesLoose");

/***/ }),

/***/ 9:
/***/ (function(module, exports) {

module.exports = require("css-loader/lib/css-base");

/***/ })

},[[541,0]]]);
});